import PageContainer from '@/common/components/PageContainer'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import useQueryGetLineMessageLogs from '@/modules/line-message-log/api/hooks/useQueryGetLineMessageLogs'
import LineMessageLogListing from '@/modules/line-message-log/components/LineMessageLogListing'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useDateFilter } from '@/common/hooks/useDateFilter'
import { useQueryState, parseAsString } from 'nuqs'
import { useEffect, useState } from 'react'
import { format, startOfDay, endOfDay } from 'date-fns'
import { LineAutoMessageLogType } from '@/schema'

function LineMessageLogPage() {
	const { pageSize, currentPage } = useTablePagination()
	const { dateFilter, setDateFilter } = useDateFilter()
	const [dateRange, setDateRange] = useQueryState(
		'dateRange',
		parseAsString.withDefault(''),
	)
	const [logTypeFilter, setLogTypeFilter] = useState<
		LineAutoMessageLogType | ''
	>('')

	useEffect(() => {
		if (!dateFilter.startDate && !dateFilter.endDate && dateRange !== 'all') {
			const today = new Date()
			setDateFilter({
				startDate: format(startOfDay(today), 'yyyy-MM-dd'),
				endDate: format(endOfDay(today), 'yyyy-MM-dd'),
			})
			setDateRange('today')
		}
	}, [
		dateFilter.startDate,
		dateFilter.endDate,
		dateRange,
		setDateFilter,
		setDateRange,
	])

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		startDate: dateFilter.startDate || undefined,
		endDate: dateFilter.endDate || undefined,
		logType: logTypeFilter || undefined,
	}

	const { data, isLoading } = useQueryGetLineMessageLogs(payload)

	return (
		<PageContainer>
			<LineMessageLogListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
				logTypeFilter={logTypeFilter}
				onLogTypeChange={setLogTypeFilter}
			/>
		</PageContainer>
	)
}

const GuardedLineMessageLogPage = withUserPermission(LineMessageLogPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_CHAT],
})

export default GuardedLineMessageLogPage
